import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../api.js'
import { Card, Alert } from '../lib.jsx'

function friendlyErr(e) {
  if (e.status === 503) return { kind: 'warn', text: 'Płatności nie są jeszcze skonfigurowane (brak klucza Stripe w panelu administratora).' }
  return { kind: 'err', text: e.message || 'Wystąpił błąd' }
}

export default function Billing() {
  const [params, setParams] = useSearchParams()
  const [me, setMe] = useState(null)
  const [plans, setPlans] = useState([])
  const [err, setErr] = useState(null)
  const [busyId, setBusyId] = useState(null)
  const [portalBusy, setPortalBusy] = useState(false)
  const [notice, setNotice] = useState(null)

  const load = () => { api.billingMe().then(setMe).catch(e => setErr(friendlyErr(e))); api.plans().then(setPlans).catch(e => setErr(friendlyErr(e))) }
  useEffect(load, [])

  useEffect(() => {
    const status = params.get('checkout') || params.get('status')
    if (status === 'success') setNotice({ kind: 'ok', text: 'Płatność zakończona sukcesem — plan zostanie zaktualizowany po potwierdzeniu przez Stripe.' })
    else if (status === 'cancel') setNotice({ kind: 'info', text: 'Zakup anulowany.' })
    if (status) {
      const next = new URLSearchParams(params)
      next.delete('checkout'); next.delete('status')
      setParams(next, { replace: true })
    }
  }, [])

  const choose = async (planId) => {
    setErr(null); setBusyId(planId)
    try {
      const successUrl = `${window.location.origin}/billing?checkout=success`
      const cancelUrl = `${window.location.origin}/billing?checkout=cancel`
      const res = await api.checkout(planId, successUrl, cancelUrl)
      window.location.assign(res.url)
    } catch (e) { setErr(friendlyErr(e)) } finally { setBusyId(null) }
  }

  const openPortal = async () => {
    setErr(null); setPortalBusy(true)
    try { const res = await api.billingPortal(); window.location.assign(res.url) }
    catch (e) { setErr(friendlyErr(e)) } finally { setPortalBusy(false) }
  }

  return (
    <>
      <div className="topbar">
        <div><h1>Płatności</h1><div className="sub">Plan konta, subskrypcja i faktury.</div></div>
      </div>
      <div className="content">
        <Alert kind={notice?.kind}>{notice?.text}</Alert>
        <Alert kind={err?.kind}>{err?.text}</Alert>

        {me && (
          <Card title="Bieżący plan" right={
            <button className="btn" disabled={portalBusy} onClick={openPortal}>{portalBusy ? 'Otwieranie…' : 'Zarządzaj płatnością'}</button>
          }>
            <div className="kvp"><span className="k">Plan</span><span>{me.plan?.name || 'Brak (darmowy)'}</span></div>
            <div className="kvp"><span className="k">Status subskrypcji</span><span>{me.subscription_status || '—'}</span></div>
            <div className="kvp"><span className="k">Odnowienie</span><span>{me.current_period_end ? new Date(me.current_period_end).toLocaleDateString('pl-PL') : '—'}</span></div>
            <div className="kvp"><span className="k">Projekty (dziś)</span><span>{me.usage?.projects ?? 0}</span></div>
          </Card>
        )}

        <Card title="Dostępne plany" desc={`${plans.length} łącznie`}>
          {plans.length === 0 ? <div className="empty">Brak dostępnych planów.</div> : (
            <div className="grid grid-3">
              {plans.map(p => (
                <div key={p.id} className="card tile" style={{ boxShadow: 'none' }}>
                  <h3>{p.name}</h3>
                  <div className="stat"><div className="v">{(p.price_monthly / 100).toFixed(2)} {p.currency}</div><div className="k">miesięcznie</div></div>
                  <button className="btn btn-primary" disabled={busyId === p.id} onClick={() => choose(p.id)}>
                    {busyId === p.id ? 'Przekierowanie…' : (me?.plan?.id === p.id ? 'Bieżący plan' : 'Wybierz')}
                  </button>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </>
  )
}
